import { FunctionComponent } from 'react';
import { Divider } from 'antd';

// components
import FilePreview from 'components/filePreview/filePreview';
import { FinancialStatement } from '../models/financialStatment';
import { formatFileSize } from 'utils/FileSize';
import { dateFormat } from 'utils/dateFormat';
import { isRTL } from 'core/services/language';

interface CompanyInfFinancialStatementItemProps {
	period: FinancialStatement[];
}

const CompanyInfFinancialStatementItem: FunctionComponent<CompanyInfFinancialStatementItemProps> = ({ period }) => {
	return (
		<>
			{period.map((item) =>
				item.documents.map((file, fileIndex) => (
					<div key={fileIndex}>
						<div className="mb-2">
							<FilePreview
								name={`${isRTL() ? item.translated_period_type.ar : item.translated_period_type.en} - ${
									isRTL() ? item.translated_type.ar : item.translated_type.en
								} - ${file.title}`}
								data={dateFormat(file.last_modified_date)}
								downloadLink={file.download_link}
								transparent
							/>
						</div>

						{item.documents.length > 1 && fileIndex < item.documents.length && <Divider className="light" />}
					</div>
				)),
			)}
		</>
	);
};

export default CompanyInfFinancialStatementItem;
